import keychain from '../resources/keychain.json';

type UserWithPassword<T> = T & { password: string };

interface SuperUser {
    name: string;
    email: string;
}

async function sha256(message: string) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

async function verifyPassword(user: string, password: string): Promise<SuperUser | null> {
    const hash = await sha256(password);
    const userObject = findUser(user);

    if (!userObject) {
        return null;
    }

    if (hash === userObject.password) {
        return userObject;
    }

    return user ? { name: userObject.name, email: userObject.email } : null;
}

function isEmail(name: string): boolean {
    const [username, domain, undefCheck]: (string | null)[] = name.split('@');

    if (!username || !domain || undefCheck !== undefined) {
        return false;
    }

    return domain.indexOf('.') >= 1 && username.indexOf(' ') < 0;
}

function findUser(nameOrEmail: string): UserWithPassword<SuperUser> | null {
    return (
        (isEmail(nameOrEmail)
            ? keychain.passwords.find(u => u.email === nameOrEmail)
            : keychain.passwords.find(u => u.name === nameOrEmail)) ?? null
    );
}

export { sha256, verifyPassword, isEmail, findUser };
